import { Component, OnInit, signal, ViewChild }                          from '@angular/core';
import { FormBuilder, FormGroup, Validators }                            from '@angular/forms';
import { MatDialog }                                                     from '@angular/material/dialog';
import { MatStepper }                                                    from '@angular/material/stepper';
import { Store }                                                         from '@ngrx/store';
import { Produit }                                                       from '@shared/classes/produit';
import { User }                                                          from '@shared/classes/user';
import { View }                                                          from '@shared/classes/view';
import { EnumOuiNon }                                                    from '@shared/enums/enumOuiNon';
import { FeatureSpinnerEnum }                                            from '@shared/enums/featureSpinner.enum';
import { ProfilEnum }                                                    from '@shared/enums/profil.enum';
import { ViewCaseEnum }                                                  from '@shared/enums/viewCase.enum';
import { getAge }                                                        from '@shared/helper/DateHelper';
import { capitalize }                                                    from '@shared/helper/LDHelper';
import { map }                                                           from 'rxjs/operators';
import { isProduction }                                                  from 'src/app/shared/constants/sharedFrontConstants';
import { reinitTarification }                                            from 'src/app/shared/ngrx/store/actions/tarification.action';
import { selectLoadingByKey }                                            from 'src/app/shared/ngrx/store/selectors/spinner.selector';
import { LocalStorageUtil }                                              from 'src/app/shared/utils/localStorageUtil';
import { goToStepByIndexForOAV, initProduits, initViews, updateTypeGAV } from '../../shared/ngrx/store/actions/bilan.actions';
import { updateState, updateUser, upsertUser }                           from '../../shared/ngrx/store/actions/user.actions';
import { selectProduits }                                                from '../../shared/ngrx/store/selectors/bilan.selector';
import { selectCaisse, selectQueryParams }                               from '../../shared/ngrx/store/selectors/config.selector';
import { selectStepEstimation }                                          from '../../shared/ngrx/store/selectors/tarif.selector';
import { selectState, selectUser }                                       from '../../shared/ngrx/store/selectors/user.selector';
import { IAppState }                                                     from '../../shared/ngrx/store/state/app.state';
import { QueryParams }                                                   from '../../shared/queryParams/queryParams';
import { TechnicalService }                                              from '../../shared/services/technical.service';
import { Etape3_trackingEnum }                                           from '../../shared/services/trackingService/button_tracking.enum';
import { TrackingService }                                               from '../../shared/services/trackingService/tracking.service';
import { Helper }                                                        from '../../shared/utils/helper';
import { HelperMain }                                                    from './helperMain';
import { SelfCareService }                                               from './self-care/self-care.service';
import { StatutBilan }                                                   from './steps/StatutBilan';
import { DialogAlertNoResultComponent }                                  from './steps/step-one/dialog-alert-no-result/dialog-alert-no-result.component';
import { CHECK_GAV, CHECK_LIST_GAV, ViewsContants }                      from './steps/step-two/views.constants';

@Component ({
              template: '',
            })
export abstract class AbstractMainComponent implements OnInit {
  @ViewChild ('stepper') private stepper: MatStepper;

  public profileFormGroup: FormGroup;
  public bottomInfo: string;
  public nextStepOne: boolean;

  public selectUser$           = this._store.select (selectUser);
  public selectStepEstimation$ = this._store.select (selectStepEstimation);
  public selectProduits$       = this._store.select (selectProduits);
  public selectCaisse$         = this._store.select (selectCaisse);
  public selectQueryParams$    = this._store.select (selectQueryParams);
  public selectLoadingBilan$   = this._store.select (selectLoadingByKey (FeatureSpinnerEnum.SAVE_BILAN));
  public selectState$          = this._store.select (selectState);

  public markAsTouched$$ = signal<EnumOuiNon> (EnumOuiNon.NON);

  protected constructor (protected _store: Store<IAppState>,
                         protected _fb: FormBuilder,
                         protected dialog: MatDialog,
                         protected _technicalService: TechnicalService,
                         private _trackingservice: TrackingService,
                         protected _selfCareService: SelfCareService,
  ) {
    this.nextStepOne      = false;
    this.profileFormGroup = this._fb.group ({
                                              nextStepCtrl: ['', Validators.required],
                                            });
  }

  ngOnInit (): void {
  }


  onBottom (event: string) {
    this.bottomInfo = event;
  }

  public onValuesStepOneHasChanged (statutBilan: StatutBilan) {
    const user = statutBilan.user;
    this._store.dispatch (updateUser ({ user }));

    this.nextStepOne = !statutBilan.invalid;
    if (!this.nextStepOne) {
      return;
    }
  }

  protected nexStepOne (user: User, queryParams: QueryParams): boolean {

    // detecte change
    this.markAsTouched$$.set (EnumOuiNon.OUI);


    // check values
    const next = HelperMain.check (user, queryParams);
    if (!next) {
      return false;
    }

    // check formgroup
    if (!this.nextStepOne) {
      return false;
    }

    // check views
    const steps = ViewsContants.getViewsAndProduits (user, getAge (user.dateDeNaissance), queryParams);
    if (steps.views.length === 0) {
      this.noView ();
      return false;
    }


    // maj des vues et produits
    steps.views.forEach (v => {
      if (v.id == ViewCaseEnum.GAV) {
        this.checkGAV (user);
      }
    });
    if (steps.products && steps.products.length > 0) {
      this._store.dispatch (initProduits ({ produits: steps.products }));
    }
    this._store.dispatch (initViews ({ views: steps.views as View[] }));


    // MAJ du store pour Step tarification
    this._store.dispatch (upsertUser ({
                                        user,
                                        caisse: queryParams.PROFIL === ProfilEnum.OAV ? LocalStorageUtil.getCaisse ().CR : null,
                                        profil: queryParams.PROFIL,
                                      }));
    if (queryParams.PROFIL === ProfilEnum.SELFCARE) {
      this._store.dispatch (updateState ({ stateUpdated: EnumOuiNon.OUI }));
    }

    // reinit tarif if user is modified
    this._store.dispatch (reinitTarification ());

    return true;
  }

  private noView () {
    this.selectQueryParams$.pipe (map ((params) => {
      let topValue: string | null;
      if (params.PROFIL === ProfilEnum.SELFCARE) {
        topValue = isProduction () ? '1200px' : null;
      } else {
        topValue = null;
      }
      this.dialog.open (DialogAlertNoResultComponent, {
        disableClose: true,
        hasBackdrop:  true,
        maxWidth:     '100vw',
        width:        '750px',
        height:       '220px',
        autoFocus:    false,
        position:     {
          top: topValue,
        },
        data:         {},
      }).afterClosed ();
    })).subscribe ();
  }

  private checkGAV (user: User) {
    let age     = getAge (user.dateDeNaissance);
    let listGAV = null;
    CHECK_LIST_GAV.filter (c => {
      if (CHECK_GAV[c] (user, age)) {
        listGAV = c;
      }
    });
    this._store.dispatch (updateTypeGAV ({ typeGAV: listGAV }));
  }

  goToStep (index: number, key: string) {
    if (key === ProfilEnum.OAV) {
      this._store.dispatch (goToStepByIndexForOAV ({ index }));
    } else {
      this.stepper.selectedIndex = index;
      if (index === 0) {
        this._store.dispatch (updateState ({ stateUpdated: EnumOuiNon.NON }));
      }
    }
  }

  scroll (el: HTMLElement) {
    el.scrollIntoView ({ behavior: 'smooth' });
  }

  scrollButtonNext (el: HTMLElement) {
    el.scrollIntoView ({ behavior: 'smooth' });
  }

  openDialogConseiller (user: User, produits: Produit[]) {
    this._trackingservice.trackButtonClick (Etape3_trackingEnum.RAPPEL_CONSEILLER);
    const civilite    = Helper.getLittleCivilite (user.civilite);
    const fileNamePdf = `${civilite} ${capitalize (user.nom)} - Votre_bilan_prevoyance_personnalise_Groupama.pdf`;
    this._selfCareService.dialogConseiller (user, fileNamePdf, produits);
  }
}
